module.exports = __webpack_public_path__ + "static/media/README_cryptochunk.97945ef8.pdf";